export const editableFieldEnUSTranslations = {
  editableFieldEdit: "Edit {{label}}: {{value}}",
  editableFieldEditing: "Editing {{label}}",
  editableFieldCancelled: "Editing cancelled. {{label}}: {{value}}",
  editableFieldSaved: "{{label}} saved: {{value}}",
  editableFieldUnchanged: "{{label}} unchanged: {{value}}",
  editableFieldNotSet: "Not set",
  editableFieldSelect: "Select...",
  editableFieldRequired: "{{label}} is required",
  editableFieldMinLength: "{{label}} must be at least {{min}} characters",
  editableFieldMaxLength: "{{label}} must be less than {{max}} characters",
  editableFieldSaveFailed: "Failed to save",
};
